import { render, staticRenderFns } from "./table-expand.vue?vue&type=template&id=c6ffd224&"
import script from "./table-expand.vue?vue&type=script&lang=js&"
export * from "./table-expand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports